module.exports = __webpack_public_path__ + "img/icon-linkedin.45b15ae5.svg";